// extracted by mini-css-extract-plugin
export default {"theme-container":"MainLayout_theme-container__6FqyR","region-pages":"MainLayout_region-pages__r1+zX","region-overlays":"MainLayout_region-overlays__ka6vT"};